var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Laravel Log Viewer")]),_c('v-card-text',[(_vm.log)?_c('pre',[_vm._v(_vm._s(_vm.log))]):_vm._e(),(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }